import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token fallback (same value stored on login)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const pin = getScoutingPin();
  if (pin) config.headers["X-Scouting-Pin"] = pin;
  const mpin = getMedicalPin();
  if (mpin) config.headers["X-Medical-Pin"] = mpin;
  const dpin = getDirectorPin();
  if (dpin) config.headers["X-Director-Pin"] = dpin;
  const apin = getAdminPin();
  if (apin) config.headers["X-Admin-Pin"] = apin;
  const anpin = getAnalysisPin();
  if (anpin) config.headers["X-Analysis-Pin"] = anpin;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err.response?.data?.detail;
    if (err.response?.status === 401 && typeof detail === "string" && detail.startsWith("Sessione terminata")) {
      try { localStorage.removeItem("pc_token"); sessionStorage.setItem("pc_session_msg", detail); } catch (e) { /* ignore */ }
      window.dispatchEvent(new Event("session-ended"));
    }
    if (err.response?.status === 402 && err.response?.data?.billing_expired) {
      window.dispatchEvent(new Event("billing-expired"));
    }
    if (err.response?.status === 423) {
      const url = err.config?.url || "";
      if (url.includes("/director")) {
        sessionStorage.removeItem("pc_director_pin");
        window.dispatchEvent(new Event("director-locked"));
      } else if (url.includes("/admin")) {
        sessionStorage.removeItem("pc_admin_pin");
        window.dispatchEvent(new Event("admin-locked"));
      } else if (url.includes("/analysis/team") || url.includes("/compare-presets") || url.includes("/starting-xi")) {
        sessionStorage.removeItem("pc_analysis_pin");
        window.dispatchEvent(new Event("analysis-locked"));
      } else if (url.includes("/analysis/medical")) {
        sessionStorage.removeItem("pc_medical_pin");
        window.dispatchEvent(new Event("medical-locked"));
      } else {
        sessionStorage.removeItem("pc_scouting_pin");
        window.dispatchEvent(new Event("scouting-locked"));
      }
    }
    return Promise.reject(err);
  }
);

export function getDirectorPin() {
  return sessionStorage.getItem("pc_director_pin") || "";
}
export function setDirectorPin(pin) {
  if (pin) sessionStorage.setItem("pc_director_pin", pin);
  else sessionStorage.removeItem("pc_director_pin");
  window.dispatchEvent(new Event("director-unlocked"));
}

export function getAdminPin() {
  return sessionStorage.getItem("pc_admin_pin") || "";
}
export function setAdminPin(pin) {
  if (pin) sessionStorage.setItem("pc_admin_pin", pin);
  else sessionStorage.removeItem("pc_admin_pin");
  window.dispatchEvent(new Event("admin-unlocked"));
}

export function getAnalysisPin() {
  return sessionStorage.getItem("pc_analysis_pin") || "";
}
export function setAnalysisPin(pin) {
  if (pin) sessionStorage.setItem("pc_analysis_pin", pin);
  else sessionStorage.removeItem("pc_analysis_pin");
  window.dispatchEvent(new Event("analysis-unlocked"));
}

export function getScoutingPin() {
  return sessionStorage.getItem("pc_scouting_pin") || "";
}
export function setScoutingPin(pin) {
  if (pin) sessionStorage.setItem("pc_scouting_pin", pin);
  else sessionStorage.removeItem("pc_scouting_pin");
  window.dispatchEvent(new Event("scouting-unlocked"));
}

export function getMedicalPin() {
  return sessionStorage.getItem("pc_medical_pin") || "";
}
export function setMedicalPin(pin) {
  if (pin) sessionStorage.setItem("pc_medical_pin", pin);
  else sessionStorage.removeItem("pc_medical_pin");
  window.dispatchEvent(new Event("medical-unlocked"));
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
